import { IkasHTMLMetaData } from ".";

export function initIkasHTMLMetaData(
  metaData: IkasHTMLMetaData,
  locale: string | null
) {
  if (locale) setHTMLMetaDataTranslations(metaData, locale);
}

export function setHTMLMetaDataTranslations(
  metaData: IkasHTMLMetaData,
  locale: string
) {
  if (
    metaData.translations &&
    metaData.translations.some((t) => t.locale === locale)
  ) {
    const localeTranslations = metaData.translations.find(
      (t) => t.locale === locale
    );

    if (localeTranslations?.pageTitle)
      metaData.pageTitle = localeTranslations.pageTitle;
    if (localeTranslations?.description)
      metaData.description = localeTranslations.description;
  }
}
